export default __webpack_public_path__ + "static/media/iai_icon.1436a0d7.png";